import { INgayNghiLe } from "../../model/respone/category/INgayNghiLe";
import { apiClient } from "../apiClient";

export const NGAY_NGHI_LE_API = "ngay-nghi-le";
export const ngayNghiLeApi = {
  SelectAll: () => apiClient.get(`${NGAY_NGHI_LE_API}`),
  Insert: (payload: INgayNghiLe) => apiClient.post(`${NGAY_NGHI_LE_API}`, payload),
  Update: (payload: INgayNghiLe) => apiClient.put(`${NGAY_NGHI_LE_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${NGAY_NGHI_LE_API}/${id}`),
};
